import { createSafeContext } from '@/package';

import type { FrameImageViewerContextValue } from './type';

const FrameImageViewerContext = createSafeContext<FrameImageViewerContextValue>(
  {} as FrameImageViewerContextValue,
  'FrameImageViewerContext',
);

export const useFrameImageViewer = () => FrameImageViewerContext.hook();

export default FrameImageViewerContext;
